import { render } from "./advanced.vue?vue&type=template&id=5f7451b4&scoped=true"
import script from "./advanced.vue?vue&type=script&lang=js"
export * from "./advanced.vue?vue&type=script&lang=js"

import "./advanced.vue?vue&type=style&index=0&id=5f7451b4&lang=scss&scoped=true"
import "./advanced.vue?vue&type=style&index=1&id=5f7451b4&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7451b4"]])

export default __exports__